module.exports = __webpack_public_path__ + "img/words9.46b3c62d.png";